import { EMPRESA_OPTIONS, MESES_OPTIONS } from "../components/Insights/insightsConstants";

export function normalizeInsightsEmpresa(empresaParam) {
  return String(empresaParam || "stage").toLowerCase();
}

export function buildExecutiveBriefingParams({
  year,
  empresa,
  mes,
  rol,
  nivel1,
  omitirGeneralStage,
} = {}) {
  const params = {
    year,
    empresa: normalizeInsightsEmpresa(empresa),
    mes,
    rol: rol || "ambos",
  };
  if (nivel1 != null && nivel1 !== "") params.nivel1 = nivel1;
  if (omitirGeneralStage != null) params.omitirGeneralStage = omitirGeneralStage;
  return params;
}

export function shouldShowInsightsRolPanels(rol) {
  const r = String(rol || "ambos").toLowerCase();
  return {
    showCeo: r === "ambos" || r === "ceo",
    showCfo: r === "ambos" || r === "cfo",
  };
}

export function getInsightsCashflowDate(briefing) {
  return (
    briefing?.cashflow?.cf_acumulado_fecha ||
    briefing?.meta?.cashflow_cf_acumulado_fecha ||
    briefing?.meta?.periodo?.corte ||
    null
  );
}

export function getInsightsEmpresaLabel(empresa, options = EMPRESA_OPTIONS) {
  return options.find((o) => o.value === empresa)?.label || empresa;
}

export function getInsightsMesLabel(mes, options = MESES_OPTIONS) {
  return options.find((o) => o.value === mes)?.label || String(mes);
}
